import React from 'react';

const HoverTooltip = ({ content, children, className = '' }) => {
  if (!content) {
    return children;
  }

  return (
    <div
      className={`group relative ${className}`}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
      }}
    >
      {children}
      <div className="pointer-events-none absolute bottom-full left-1/2 z-30 mb-2 w-max max-w-[240px] -translate-x-1/2 translate-y-1 rounded-md bg-text-primary px-3 py-2 text-center text-xs text-white opacity-0 shadow-elevation-2 transition-all duration-150 group-hover:translate-y-0 group-hover:opacity-100">
        {content}
      </div>
    </div>
  );
};

export default HoverTooltip;
